import React from 'react';
import { BulkOperationsErrorBoundary } from '../../common/ui/error-boundary/index.tsx';
import { EditFormSubmitStatusProgressPolling } from './progress-polling/index.tsx';
import { useEditFormStatusFlags } from './utils.tsx';

export const EditFormSubmitStatus = (): React.JSX.Element => {
	useEditFormStatusFlags();
	return (
		<BulkOperationsErrorBoundary id="bulk-operations.core.edit-form.submit-status.progress-polling">
			<EditFormSubmitStatusProgressPolling />
		</BulkOperationsErrorBoundary>
	);
};
